import { t } from "../i18n";
async function handleFileDownload(url, options = {}) {
  const { token, open, save, filename } = {
    token: null,
    open: true,
    save: false,
    filename: `download-${Date.now()}`,
    ...options
  };
  const headers = new Headers();
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }
  const downloadPromise = fetch(url, { headers });
  async function getObjectURL() {
    const res = await downloadPromise;
    const blobby = await res.blob();
    const objectUrl = window.URL.createObjectURL(blobby);
    return objectUrl;
  }
  if (!open && !save) {
    return getObjectURL();
  }
  if (save) {
    const objectUrl = await getObjectURL();
    const a = document.createElement("a");
    a.href = objectUrl;
    a.setAttribute("target", "_blank");
    a.setAttribute("download", filename);
    a.click();
    URL.revokeObjectURL(objectUrl);
    return objectUrl;
  }
  if (open) {
    const newTab = window.open("", "_blank");
    if (newTab) {
      newTab.document.write(t("Downloading..."));
      const objectUrl = await getObjectURL();
      newTab.location.href = objectUrl;
      URL.revokeObjectURL(objectUrl);
      return objectUrl;
    }
  }
}
var handleFileDownload_default = handleFileDownload;
export {
  handleFileDownload_default as default
};
